import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, Observable, Subscription, take, tap } from 'rxjs';
import { UserLevelEnum } from 'src/app/auth/models/UserData';
import { CompetenceService } from 'src/app/modules/competences/services/competences.service';
import { CurrentConversationSectionItemChosenItem } from 'src/app/modules/conversations/models/CurrentConversationSectionItemChosenItem';
import { CommentKind, DevelopmentObjective, DevelopmentObjectiveComment, EmployeeContractWrapper } from 'src/app/modules/development-objectives/models/DevelopmentObjective';
import { CourseWidgetsService } from 'src/app/modules/framework/home-pages/employee-home-page/services/course-widgets.service';
import { ICompanyObjectiveSettings } from 'src/app/modules/performance-objectives/models/CompanyObjectiveSettings';
import { DialogService } from 'src/app/shared/dialogs/services/DialogService';
import { LabelContext } from 'src/app/shared/framework/labels/models/LabelContext';
import { LabelService } from 'src/app/shared/framework/labels/services/label.service';
import { BreakpointObserverService } from 'src/app/shared/framework/navigation/services/breakpoint-observer.service';
import { Employee } from 'src/app/shared/personnel-files/models/Employee';
import { EmployeeService } from 'src/app/shared/personnel-files/services/employee.service';
import { DevelopmentObjectiveService } from '../../services/development-objective-service';
import { UserService } from 'src/app/auth/services/user.service';

@Component({
  selector: 'app-employee-development-objectives',
  templateUrl: './employee-development-objectives.component.html',
  styleUrls: ['./employee-development-objectives.component.scss'],
})
export class EmployeeDevelopmentObjectivesComponent implements OnInit, OnDestroy, AfterViewInit {
  private subscriptions: Subscription[] = [];
  private _labelContext: LabelContext;
  private added = false;
  private showInitialGoalId: number;

  public objectiveContractWrapper: EmployeeContractWrapper[];
  public inactiveObjectiveContractWrapper: EmployeeContractWrapper[];
  public isScreenSmall$: Observable<boolean>;

  public isManager = false;
  public IsHr = false;
  public isEmployee = false;
  public isCHR = false;
  public isLHR = false;
  public isSupervisor = false;
  public isDelegate = false;
  public isMatrixManager = false;
  public isN2 = false;
  public Roles = UserLevelEnum;
  public CommentKind = CommentKind;

  public saving: boolean = false;
  public loaded: boolean;
  public showObjectivesDetails: { [key: number]: boolean } = {};

  public settings: ICompanyObjectiveSettings;
  public settingsEmployee: ICompanyObjectiveSettings;

  public editMode = false;
  public activeObjective: DevelopmentObjective;
  public objectiveEditing: DevelopmentObjective = new DevelopmentObjective();
  public objectiveCommentAdding: DevelopmentObjectiveComment = new DevelopmentObjectiveComment();
  public employeeStudentId: number;

  /** The employee whose goals are displayed */
  public _studentId: number;
  public student: Employee;
  /** The employee currently logged on */
  public currentStudentId: number;
  /** The type of user currently logged on */
  public whoisKind: number;

  /** Check if there are courses in the catalog tha can be linked to */
  public coursesAvailable = false;

  @ViewChild('addObjectiveModal') addObjectiveModal: any;

  @Input() studentId: number;
  @Input() smallLayout: boolean = false;
  @Input() minGoals: number = 0;
  @Input() maxGoals: number = 999;
  @Input() completedConversation: number = null;
  @Input() disableNegativeMargin = false;
  @Output() goalCountChanged = new EventEmitter<number>();
  @Output() newChosenDevelopmentObjective = new EventEmitter<DevelopmentObjective>();

  private _conversationGoals: CurrentConversationSectionItemChosenItem[];
  @Input()
  public get conversationGoals(): CurrentConversationSectionItemChosenItem[] {
    return this._conversationGoals;
  }
  public set conversationGoals(value: CurrentConversationSectionItemChosenItem[]) {
    console.error(value);
    this._conversationGoals = value;
  }

  constructor(
    private breakpointObserverService: BreakpointObserverService,
    private employeeService: EmployeeService,
    private developmentObjectiveService: DevelopmentObjectiveService,
    private toastr: ToastrService,
    private _labelService: LabelService,
    private courseService: CourseWidgetsService,
    private competenceService: CompetenceService, // needed for select modal
    private _userService: UserService,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private dialogService: DialogService
  ) {
    this.isScreenSmall$ = this.breakpointObserverService.isScreenSmall$;
  }

  async ngOnInit() {
    this._labelContext = await firstValueFrom(this._labelService.getContext('general'));
    this.getData();
  }

  ngAfterViewInit(): void {
    try {
      window.scrollTo(0, 0);
      window.parent.scrollTo(0, 0);
      window.parent.parent.document.getElementsByClassName('modal-body')[0].scrollTo(0, 0);
    }
    catch (e) { }
  }

  @HostListener('window:resize')
  resizeFrame() {
    setTimeout(() => {
      try {
        (<any>window.top).initIframeResize();
      } catch (e) { }
    }, 500);
  }

  public canAdd() {
    let totalObjectivesCount = 0;

    if (this.conversationGoals && this.conversationGoals.length) {
      totalObjectivesCount = this.conversationGoals.length || 0;
    } else {
      totalObjectivesCount = this.objectiveContractWrapper?.reduce(
        (acc, wrapper) => acc + (wrapper.items?.filter(o => o.status < 3)?.length ?? 0),
        0
      ) || 0;
    }

    return (!this.maxGoals || this.maxGoals <= 0 || this.maxGoals > totalObjectivesCount) && !this.completedConversation;
  }

  // public toggleCollapseObjective(id: number): void {
  //   const isExpanded = this.showObjectivesDetails[id];
  //   this.getDevGoals();

  //   this.showObjectivesDetails = {};
  //   this.editMode = false;
  //   if (!isExpanded) {
  //     this.showObjectivesDetails[id] = true;

  //     for (const wrapper of this.objectiveContractWrapper) {
  //       const objective = wrapper.items?.find(item => item.studentIdpActivityId === id);
  //       if (objective) {
  //         this.activeObjective = JSON.parse(JSON.stringify(objective));
  //         break;
  //       }
  //     }
  //   }
  // }

  public toggleCollapseObjective(id: number, obj?: DevelopmentObjective): void {
    const isExpanded = this.showObjectivesDetails[id];

    this.showObjectivesDetails = {};
    this.editMode = false;

    if (!isExpanded) {
      this.showObjectivesDetails[id] = true;

      const source = obj ?? this.findObjectiveById(id);
      if (source) {
        this.activeObjective = JSON.parse(JSON.stringify(source));
        this.objectiveCommentAdding = new DevelopmentObjectiveComment();
        this.objectiveCommentAdding.commentKind = CommentKind.PrivateComment;
      }
    }
  }

  public isObjectiveExpanded(id: number): boolean {
    return this.showObjectivesDetails[id] === true;
  }

  public saveRights() {
    this.subscriptions.push(
      this.developmentObjectiveService.saveRights(this.settingsEmployee.allowDevelopmentGoalsCreate, this.settingsEmployee.allowDevelopmentGoalsEdit, this.settingsEmployee.allowDevelopmentGoalsDelete, this._studentId).subscribe(() => {
        let label = this._labelContext.get('savedsuccessfully').labelText;
        this.toastr.clear();
        this.toastr.success(label, undefined, { timeOut: 1000 });
      })
    );
  }

  public addObjective(modalContent) {
    try {
      window.scrollTo(0, 0);
      window.parent.scrollTo(0, 0);
      window.parent.parent.document.getElementsByClassName('modal-body')[0].scrollTo(0, 0);
    }
    catch (e) { }

    this.objectiveEditing = new DevelopmentObjective();

    this.modalService.open(modalContent, { backdrop: 'static', scrollable: true, size: 'lg' }).result.then(() => {
      this.objectiveEditing.studentId = this._studentId;
      this.objectiveEditing.studentIdpId = 0;
      this.objectiveEditing.createdById = this.currentStudentId;
      this.objectiveEditing.createdByType = this.whoisKind;

      this.subscriptions.push(
        this.developmentObjectiveService.addDevGoal(this.objectiveEditing).subscribe((e) => {
          if (this.conversationGoals && this.conversationGoals.length) {
            this.objectiveEditing.studentIdpActivityId = e;
            this.newChosenDevelopmentObjective.emit(this.objectiveEditing);
            this.conversationGoals.push({
              itemId: e,
              name: this.objectiveEditing.name
            });
          }

          this.getDevGoals();

          let label = this._labelContext.get('savedsuccessfully').labelText;
          this.toastr.clear();
          this.toastr.success(label, undefined, { timeOut: 1000 });
          this.objectiveEditing = new DevelopmentObjective();
        })
      );

    }, () => {
      this.objectiveEditing = new DevelopmentObjective();
    })
  }

  public updateObjective(event: Event, objective: DevelopmentObjective) {
    event.stopPropagation();

    const id = objective.studentIdpActivityId;

    // Expand the card
    this.showObjectivesDetails = {}; // Collapse all others
    this.showObjectivesDetails[id] = true;

    // Set active and enable edit mode
    this.activeObjective = JSON.parse(JSON.stringify(objective));
    this.editMode = true;
  }

  public saveObjectiveChanges(objective: DevelopmentObjective) {
    if (objective.studentIdpActivityId == this.activeObjective.studentIdpActivityId && this.editMode) {
      this.editMode = false;

      this.developmentObjectiveService.updateDevGoal(this.activeObjective).subscribe(() => {
        let label = this._labelContext.get('savedsuccessfully').labelText;
        this.toastr.clear();
        this.toastr.success(label, undefined, { timeOut: 1000 });

        this.getDevGoals();
      });
    }
  }

  public cancelObjectiveChanges(objective: DevelopmentObjective) {
    if (objective.studentIdpActivityId == this.activeObjective.studentIdpActivityId && this.editMode) {
      this.editMode = false;
      this.getDevGoals();
    }
  }

  public deleteObjective(event: Event, objective: DevelopmentObjective) {
    event.stopPropagation();
    let message = this._labelContext.get('action_cannot_be_undone').labelText;
    let title = this._labelContext.get('are_you_sure').labelText;
    this.dialogService.confirm({ message: message, title: title, centered: false })
      .then(() => {
        this.subscriptions.push(
          this.developmentObjectiveService.deleteDevGoal(objective.studentIdpActivityId).subscribe(() => {
            this.getDevGoals(true);
          })
        );
      }, () => { })
  }

  public addComment(objective: DevelopmentObjective) {
    this.objectiveCommentAdding.studentIDPActivityId = objective.studentIdpActivityId;
    this.objectiveCommentAdding.studentIDPId = objective.studentIdpId;
    this.objectiveCommentAdding.studentId = objective.studentId;
    this.objectiveCommentAdding.createdById = this.currentStudentId;
    this.objectiveCommentAdding.createdByType = this.whoisKind;
    this.objectiveCommentAdding.dueDate = objective.dueDate;
    this.objectiveCommentAdding.when = objective.when;
    this.objectiveCommentAdding.measurement = objective.measurement;
    this.objectiveCommentAdding.viewableByAdmin = true;
    this.objectiveCommentAdding.viewableByMgr = true;
    this.objectiveCommentAdding.viewableByStudent = true;

    this.subscriptions.push(
      this.developmentObjectiveService.addDevComment(this.objectiveCommentAdding).subscribe((e) => {
        this.subscriptions.push(
          this.developmentObjectiveService.getDevComments(objective.studentIdpActivityId).subscribe((e) => {
            objective.comments = e;
            this.activeObjective = objective;
            this.objectiveCommentAdding = new DevelopmentObjectiveComment();
            this.objectiveCommentAdding.commentKind = CommentKind.PrivateComment;
          })
        );
      })
    );
  }

  public deleteComment(comment: DevelopmentObjectiveComment) {
    let objectiveId = comment.studentIDPActivityId;

    let message = this._labelContext.get('action_cannot_be_undone').labelText;
    let title = this._labelContext.get('are_you_sure').labelText;
    this.dialogService.confirm({ message: message, title: title, centered: false })
      .then(() => {
        this.subscriptions.push(
          this.developmentObjectiveService.deleteDevComment(comment.studentIDPNoteId).subscribe(() => {
            this.subscriptions.push(
              this.developmentObjectiveService.getDevComments(objectiveId).subscribe((e) => {
                const wrapper = this.objectiveContractWrapper.filter(w => w.items && w.items.filter(o => o.studentIdpActivityId === objectiveId).length > 0);
                if (wrapper.length) {
                  const objectiveItem = wrapper[0].items.filter(o => o.studentIdpActivityId === objectiveId);
                  if (objectiveItem.length) {
                    const objective = objectiveItem[0];
                    objective.comments = e;
                    this.activeObjective = objective;
                  }
                }

                let label = this._labelContext.get('savedsuccessfully').labelText;
                this.toastr.clear();
                this.toastr.success(label, undefined, { timeOut: 1000 });
              })
            );
          })
        );
      }, () => { })
  }

  public checkWhoCanSeeComment(comment: DevelopmentObjectiveComment): boolean {
    const isCreator =
      comment.createdById === this.currentStudentId &&
      comment.createdByType === this.whoisKind;
    if (comment.commentKind === CommentKind.PrivateComment) {
      return isCreator;
    }

    if (comment.commentKind === CommentKind.PrivateCommentSharedWithinOwnRole) {
      if (comment.createdByType === this.whoisKind) {
        return true;
      }
    }

    if (comment.commentKind === CommentKind.PrivateCommentSharedBetweenManagersOrHr) {
      const userIsHr = this.isCHR || this.isLHR;
      const userIsManager = this.isSupervisor || this.isDelegate || this.isMatrixManager || this.isN2;

      const creatorIsHr = comment.createdByType === 1 || comment.createdByType === 2;
      const creatorIsManager = comment.createdByType === 33 || comment.createdByType === 333 || comment.createdByType === 3333 || comment.createdByType === 4;

      if (userIsHr && creatorIsHr) {
        return true;
      }

      if (userIsManager && creatorIsManager) {
        return true;
      }

      return false;
    }

    if (comment.commentKind == CommentKind.SharedComment) {
      return true;
    }

    return false;
  }

  public getCommentKindLabel(comment: DevelopmentObjectiveComment): string {
    switch (comment.commentKind) {
      case CommentKind.PrivateComment:
        return 'comment_setting_1';

      case CommentKind.PrivateCommentSharedWithinOwnRole:
        if (this.isCHR) {
          return 'private_comment_shared_with_others_hr_1';
        }
        if (this.isLHR) {
          return 'private_comment_shared_with_others_hr_2';
        }
        if (this.isSupervisor) {
          return 'private_comment_shared_with_others_1';
        }
        if (this.isDelegate) {
          return 'private_comment_shared_with_others_2';
        }
        if (this.isMatrixManager) {
          return 'private_comment_shared_with_others_3';
        }
        if (this.isN2) {
          return 'private_comment_shared_with_others_4';
        }

      case CommentKind.PrivateCommentSharedBetweenManagersOrHr:
        if (this.isCHR) {
          return 'comment_setting_shared_with_HR_1';
        }
        if (this.isLHR) {
          return 'comment_setting_shared_with_HR_2';
        }
        if (this.isSupervisor) {
          return 'comment_setting_shared_with_manager_1';
        }
        if (this.isDelegate) {
          return 'comment_setting_shared_with_manager_2';
        }
        if (this.isMatrixManager) {
          return 'comment_setting_shared_with_manager_3';
        }
        if (this.isN2) {
          return 'comment_setting_shared_with_manager_4';
        }

      case CommentKind.SharedComment:
        return 'comment_setting_4';

      default:
        return 'comment_setting_1';
    }
  }

  public getStatusName(status: number) {
    switch (status) {
      case 1: return 'not_started';
      case 2: return 'started';
      case 3: return 'finished';
    }
    return 'not_started';
  }

  public getStatusClass(status: number) {
    switch (status) {
      case 1: return '#bfbfbf';
      case 2: return '#ee7622';
      case 3: return '#28a745';
    }
    return 'not_started';
  }

  public openObjectiveDetail(objective: DevelopmentObjective) {
    if (this.editMode) {
      this.editMode = false;
      this.activeObjective = objective;
      this.getDevGoals();
    } else {
      this.activeObjective = objective;
    }

    this.objectiveCommentAdding = new DevelopmentObjectiveComment();
    this.objectiveCommentAdding.commentKind = CommentKind.PrivateComment;
  }

  public selectedCourse($event) {
    if (this.editMode) {
      this.activeObjective.courseId = $event[0].id;
      this.activeObjective.courseName = $event[0].name;
    } else {
      this.objectiveEditing.courseId = $event[0].id;
      this.objectiveEditing.courseName = $event[0].name;
    }
  }

  public selectedCompetency($event) {
    if (this.editMode) {
      this.activeObjective.competencyId = $event[0].id;
      this.activeObjective.competencyName = $event[0].longName;

    } else {
      this.objectiveEditing.competencyId = $event[0].id;
      this.objectiveEditing.competencyName = $event[0].longName;
    }
  }

  public isInCurrentConversation(studentIdpActivityId: number): boolean {
    return !this.conversationGoals || !this.conversationGoals.length || this.conversationGoals.filter(e => e.itemId == studentIdpActivityId).length > 0;
  }

  ngOnDestroy() {
    for (const subsc of this.subscriptions) {
      subsc.unsubscribe();
    }
  }

  private getDevGoals(forceActive?: boolean) {
    this.subscriptions.push(
      this.developmentObjectiveService
        .getDevGoals(this._studentId, this.completedConversation)
        .subscribe((e: EmployeeContractWrapper[]) => {
          for (const contract of e) {
            for (const objective of contract.items) {
              objective.canUpdate = (this.isManager || this.IsHr || this.settings.allowDevelopmentGoalsEdit) &&
                (
                  (!this.settings.devGoalsOutsideActiveGoalYearEditable && objective.reviewPeriodId >= this.settings.currentGoalPeriod) ||
                  (
                    this.settings.devGoalsOutsideActiveGoalYearEditable &&
                    (
                      (this.settings.devGoalsOutsideActiveGoalYearEditableIfNotFinished && objective.status < 3) ||
                      (!this.settings.devGoalsOutsideActiveGoalYearEditableIfNotFinished)
                    )
                  )
                ) && !this.completedConversation
            }
          }

          const filtered = e.filter(obj => obj.studentStatus === 1 || obj.studentStatus === 3);

          if (filtered.length > 0) {
            const firstObjective = filtered[0];
            const sortedRest = filtered.slice(1).sort((a, b) =>
              a.functionName.localeCompare(b.functionName) ||
              a.departmentName.localeCompare(b.departmentName) ||
              a.companyName.localeCompare(b.companyName)
            );
            this.objectiveContractWrapper = [firstObjective, ...sortedRest];
          } else {
            this.objectiveContractWrapper = filtered;
          }

          this.inactiveObjectiveContractWrapper = e
            .filter(obj => obj.studentStatus === 2)
            .sort((a, b) =>
              a.functionName.localeCompare(b.functionName) ||
              a.departmentName.localeCompare(b.departmentName) ||
              a.companyName.localeCompare(b.companyName));


          this.goalCountChanged.next(
            this.objectiveContractWrapper.map(wrapper => wrapper.items).reduce((acc, items) => acc
              .concat(items), [])
              .filter(item => item.status < 3).length
          );

          if (!this.activeObjective || forceActive || this.showInitialGoalId) {
            let found = null;
            if (this.showInitialGoalId) {
              found = this.objectiveContractWrapper.reduce((a: DevelopmentObjective[], b) => a.concat(b.items), []).filter(e => e.studentIdpActivityId == this.showInitialGoalId)[0];

              if (found) {
                this.openObjectiveDetail(found);
              }
            }

            if (!found && this.objectiveContractWrapper.length && this.objectiveContractWrapper[0].items.length) {
              this.openObjectiveDetail(this.objectiveContractWrapper[0].items?.filter(e => !this.conversationGoals || this.conversationGoals.some(g => g.itemId == e.studentIdpActivityId))[0]);
            } else if (!this.activeObjective) {
              this.activeObjective = this.objectiveContractWrapper[0].items?.filter(e => !this.conversationGoals || this.conversationGoals.some(g => g.itemId == e.studentIdpActivityId))[0];
            }
          }

          if (!this.added) {
            setTimeout(() => {
              this.subscriptions.push(
                this.activatedRoute.queryParamMap.subscribe((queryParams) => {
                  if (queryParams.has('dotnetadd') && parseInt(queryParams.get('dotnetadd')) == 1) {
                    this.addObjective(this.addObjectiveModal);
                    this.added = true;
                  }
                })
              );
            }, 500);
          }

          this.loaded = true;
          this.resize();
        })
    );
  }

  // Helper to find an objective by id 
  private findObjectiveById(id: number): DevelopmentObjective | null {
    for (const wrapper of this.objectiveContractWrapper || []) {
      const obj = wrapper.items?.find(i => i.studentIdpActivityId === id);
      if (obj) return obj;
    }
    return null;
  }

  private resize() {
    setTimeout(() => {
      try {
        (<any>window.top).initIframeResize();
        if (window.document.body) {
          window.document.body.style.height = "100%";
        }
      } catch (e) { }
    });
  }

  private getRoles() {
    if (localStorage.getItem('corporatehr_view') === '1') {
      this.isCHR = true;
    }
    if (localStorage.getItem('localhr_view') === '1') {
      this.isLHR = true;
    }
    if (localStorage.getItem('manager_view') === '1') {
      this.isSupervisor = true;
    }
    if (localStorage.getItem('n2_capital') === '1') {
      this.isN2 = true;
      this.isSupervisor = false;
    }
    if (localStorage.getItem('matrixmanager_view') === '1') {
      this.isMatrixManager = true;
      this.isSupervisor = false;
    }
    if (localStorage.getItem('delegate_view') === '1') {
      this.isDelegate = true;
      this.isSupervisor = false;
    }
  }

  private computeWhoisKindFromView(): number {
    if (this.isCHR) return 1;
    if (this.isLHR) return 2;
    if (this.isN2) return 4;
    if (this.isMatrixManager) return 3333;
    if (this.isDelegate) return 333;
    if (this.isSupervisor) return 33;
    return 3;
  }

  private getData() {
    this.isManager = localStorage.getItem('manager_view') === '1' || localStorage.getItem('delegate_view') === '1';

    this.IsHr = localStorage.getItem('localhr_view') === '1' || localStorage.getItem('corporatehr_view') === '1';
    this.isEmployee = (!this.isManager && !this.IsHr);

    this.getRoles();

    this.subscriptions.push(
      this.activatedRoute.queryParamMap.subscribe((queryParams) => {
        if (queryParams.has('goal')) {
          this.showInitialGoalId = parseInt(queryParams.get('goal'));
        }

        if (queryParams.has('item') || this.studentId) {
          this._studentId = queryParams.has('item') ? parseInt(queryParams.get('item')) : this.studentId;

          this.subscriptions.push(
            this.employeeService.getEmployee(this._studentId).subscribe((emp) => {
              this.student = emp;
              this.employeeStudentId = emp.id;
            })
          );

          this.subscriptions.push(
            this.employeeService.getCurrentEmployee().subscribe(employee => {
              this.currentStudentId = employee.studentId;
              // let level = 3;

              // switch (employee.level) {
              //   case UserLevelEnum.CorporateHr:
              //     level = 1;
              //     break;
              //   case UserLevelEnum.LocalHr:
              //     level = 2;
              //     break;
              //   case UserLevelEnum.Employee:
              //     level = 3;
              //     break;
              //   case UserLevelEnum.Manager:
              //     level = 33;
              //     break;
              //   case UserLevelEnum.Delegate:
              //     level = 333;
              //     break;
              //   case UserLevelEnum.MatrixManager:
              //     level = 3333;
              //     break;
              // }
              this.whoisKind = this.computeWhoisKindFromView();

              let studentIdForSettings = employee.level == UserLevelEnum.Employee ? employee.studentId : 0;

              // Managers shoud always get all rights for the employee they are viewing
              if (this.isManager) {
                studentIdForSettings = 0;
              }

              this.subscriptions.push(
                this.developmentObjectiveService.getSettings(studentIdForSettings, true).pipe(take(1)).subscribe((s) => {
                  this.settings = s;

                  this.subscriptions.push(
                    this.developmentObjectiveService.getSettings(this._studentId, true).pipe(take(1)).subscribe((e) => {
                      this.settingsEmployee = e;
                      this.getDevGoals();
                    })
                  );
                })
              );
            })
          );
        } else {
          this.subscriptions.push(
            this.employeeService.getCurrentEmployee().subscribe(employee => {
              this.currentStudentId = employee.studentId;
              this._studentId = employee.studentId;
              this.whoisKind = 3;

              this.subscriptions.push(
                this.employeeService.getEmployee(this._studentId).subscribe((emp) => {
                  this.student = emp;
                })
              );

              this.subscriptions.push(
                this.developmentObjectiveService.getSettings(employee.studentId).subscribe((s) => {
                  this.settings = s;
                  this.settingsEmployee = s;
                  this.getDevGoals();
                })
              );
            })
          );
        }
      })
    );


    this.subscriptions.push(
      this.courseService.countAllCourses({ search: '', page: 0, pageSize: 999999 }).subscribe((e) => {
        this.coursesAvailable = e > 0;
      })
    );
  }
}